import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Ellipses.svg?component
var Ellipses_exports = /* @__PURE__ */ __exportAll({
	default: () => Ellipses_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M6 11c-.5 0-1 .4-1 1s.5 1 1 1 1-.4 1-1-.5-1-1-1m12 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m-6 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1" }, null, -1)])]);
}
var Ellipses_default = { render: render$1 };
//#endregion
export { Ellipses_exports, Ellipses_default as default, render$1 as render };

//# sourceMappingURL=Ellipses.svg.virtual.js.map